import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: 8,
    padding: '12px 16px 12px 16px',
    borderRadius: 16,
    display: 'grid',
    boxShadow: '0 2px 9px 0 rgb(0 0 0 / 19%)',
    backgroundColor: theme.palette.background.default
  },
  root2: {
    marginTop: 248
  },
  readMode: {
    display: 'flex',
    width: '100%',
    height: '100%',
    background: theme.palette.grey[800],
    alignItems: 'center'
  },
  searchContainer: {
    display: 'flex',
    background: theme.palette.primary.main,
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    width: 50,
    height: 50,
    marginRight: 8
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: 4
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 6
  },
  title: { fontWeight: 600, color: theme.palette.grey[200], fontSize: 11 },
  title2: { fontWeight: 600, color: theme.palette.grey[200] },
  icon: {
    fontSize: 30,
    color: theme.palette.primary.contrastText
  },
  separator: {
    width: 'calc(100% - 12px)',
    marginTop: 18,
    marginBottom: 7,
    borderTop: 'solid 1px #ababab'
  },
  columnSeparator: {
    width: 2,
    height: '100%'
  },
  buttonBase: {
    width: '100%'
  },
  searchIcon: {
    fontSize: '24px'
  },
  btnText: { fontSize: 18, color: theme.palette.primary.contrastText },

  searchButtonContianer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 16
  },
  searchButton: {
    borderRadius: 8,
    width: '100%',
    height: 48
  },
  dateModal: {
    top: -12,
    right: 0,
    position: 'absolute',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    zIndex: 10000,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    borderRadius: 9,
    backgroundColor: theme.palette.background.default
  },
  nightContainer: {
    height: 'calc(100% + 30px)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: 20,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    borderRadius: 9
  },
  guestModal: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    [theme.breakpoints.down('sm')]: {
      top: 210
    },
    minWidth: 280,
    padding: '16px',
    maxHeight: 460,
    zIndex: 1000,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    backgroundColor: theme.palette.background.default,
    borderRadius: 8
  },
  dateModalContainer: {
    display: 'grid',
    gridTemplateColumns: '4fr 1fr 4fr',
    alignItems: 'center'
  }
}))
export default useStyles
